/* eslint-disable */
import {
  Box,
  Button,
  Grid,
  IconButton,
  TextField,
  Typography,
  Paper,
  Tooltip,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { Cancel, DoNotDisturbOn, KeyboardReturn } from "@mui/icons-material";
import RemoveRedEyeOutlinedIcon from "@mui/icons-material/RemoveRedEyeOutlined";
import RemoveCircleOutlineOutlinedIcon from "@mui/icons-material/RemoveCircleOutlineOutlined";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  getEnvioAnteojoArreglo,
  invalidateEnvioAnteojoArreglo,
} from "../../services/EnvioAnteojoArregloService.js";
import Message from "../../utils/Message.jsx";
import EnvioAnteojoArregloDialog from "./EnvioAnteojoArregloDialog.jsx";
import VerAnteojoArregloDialog from "./../produccion/VerAnteojoArregloDialog.jsx";
import WaitingDialog from "../../utils/WaitingDialog";
import { format } from "date-fns";

const initialEnvioAnteojoArregloData = {
  codigoEnvioAnteojoArreglo: "",
  sucursalDestino: "",
  fechaRegistracion: format(new Date(), "dd/MM/yyyy"),
  observaciones: "",
  anulado: false,
  motivoAnulacion: "",
};

const nameItemsText = "Envio de Anteojos / Arreglos";
//
// ###########################################################################
//
const EnvioAnteojoArreglo = () => {
  const navigate = useNavigate();
  const { action, idEnvioAnteojoArreglo } = useParams();
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [message, setMessage] = useState({});
  const [showMessage, setShowMessage] = useState(false);
  const [title, setTitle] = useState("");
  const [envioAnteojoArregloData, setEnvioAnteojoArregloData] = useState(
    initialEnvioAnteojoArregloData
  );
  const [envioAnteojoArregloList, setEnvioAnteojoArregloList] = useState([]);
  const [anteojoArregloItem, setAnteojoArregloItem] = useState({});
  const [openAnteojoArregloDialog, setOpenAnteojoArregloDialog] = useState(false);
  const [envioAnteojoArregloEstadoRows, setEnvioAnteojoArregloEstadoRows] = useState([]);
  const [actionCrud, setActionCrud] = useState("");
  const [openVerAnteojoArregloDialog, setOpenVerAnteojoArregloDialog] = useState(false);
  const [anteojoArreglo, setAnteojoArreglo] = useState("");
  const [idGestionAtencion, setIdGestionAtencion] = useState("");
  const [idGcAnteojoArreglo, setIdGcAnteojoArreglo] = useState("");
  const [codigoAnteojoArreglo, setCodigoAnteojoArreglo] = useState("");

  const tableColumns = [
    {
      field: "codigo_anteojo_arreglo",
      headerName: "Código",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "anteojo_arreglo",
      headerName: "Tipo",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.anteojo_arreglo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "codigo_gc",
      headerName: "Código GC",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.codigo_gc;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "cliente",
      headerName: "Cliente",
      headerAlign: "center",
      flex: 1,
      minWidth: 300,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.nombre_cliente + " " + params.row.apellido_cliente;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
    {
      field: "actions",
      headerName: "Acciones",
      width: 200,
      sortable: false,
      filterable: false,
      headerAlign: "center",
      align: 'left',
      renderCell: (params) => (
        <>
          <Tooltip title="ver">
            <IconButton
              size="small"
              aria-label="update"
              onClick={() => handleAnteojoArreglo(params.row)}
            >
              <RemoveRedEyeOutlinedIcon />
            </IconButton>
          </Tooltip>
        </>
      ),
    },
  ];

  const tableColumnsEstado = [
    {
      field: "estado",
      headerName: "Estado",
      headerAlign: "center",
      flex: 1,
      minWidth: 130,
      sortable: false,
      renderCell: (params) => {
        let _val = "ERR";
        switch (params.row.estado) {
          case "pendiente-recibir":
            _val = "PENDIENTE DE RECIBIR";
            break;
          case "recibido":
            _val = "RECIBIDO";
            break;
          case "anulado":
            _val = "ANULADO";
            break;
        }
        return _val;
      },
    },
    {
      field: "ultimo_estado",
      headerName: "Estado actual",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.ultimo_estado ? "SI" : "";
        return _val;
      },
    },
    {
      field: "fecha_estado",
      headerName: "Fecha de estado",
      flex: 1,
      headerAlign: "center",
      minWidth: 150,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.fecha_estado;
        _val = _val ? _val : "";
        return _val;
      },
    },
    {
      field: "username",
      headerName: "Vendedor/Operador",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.username;
        _val = _val ? _val.toLowerCase() : "";
        return _val;
      },
    },
    {
      field: "motivo",
      headerName: "Motivo de anulación",
      headerAlign: "center",
      flex: 1,
      minWidth: 100,
      sortable: false,
      renderCell: (params) => {
        let _val = params.row.motivo;
        _val = _val ? _val.toUpperCase() : "";
        return _val;
      },
    },
  ];

  const tableOptions = {
    rowHeight: 40,
    columnHeaderHeight: 45,
    disableRowSelectionOnClick: true,
    disableColumnMenu: true,
    disableColumnFilter: true,
    disableColumnSelector: true,
    disableDensitySelector: true,
    hideFooter: true,
    localeText: {
      noRowsLabel: "",
      noResultsOverlayLabel: "",
    },
    sx: {
      "& .MuiDataGrid-cell": {
        fontSize: "0.9em",
      },
      "& .MuiDataGrid-columnHeaders": {
        backgroundColor: "#f5f5f5",
      },
    },
  };
  //
  // ################################################################################
  //
  useEffect(() => {
    if (action === "view") {
      setTitle("Ver " + nameItemsText + " " + envioAnteojoArregloData.codigoEnvioAnteojoArreglo);
    } else if (action === "delete") {
      setTitle("Anular " + nameItemsText + " " + envioAnteojoArregloData.codigoEnvioAnteojoArreglo);
    }

    const loadEnvioAnteojoArreglo = async () => {
      setIsDoingSomething(true);
      const response = await getEnvioAnteojoArreglo(idEnvioAnteojoArreglo);
      setIsDoingSomething(false);

      if (response.ok) {
        let _envioAnteojoArregloData = response.data.data;
        let _envioAnteojoArregloList = _envioAnteojoArregloData.envio_anteojo_arreglo_list;
        let _envioAnteojoArregloEstados =
          _envioAnteojoArregloData.envio_anteojo_arreglo_estado_list;
        let _ultimo_estado_object = _envioAnteojoArregloEstados.find(
          (item) => item.ultimo_estado === true
        );

        let _anulado = _ultimo_estado_object.estado === "anulado";
        let _motivoAnulacion = _ultimo_estado_object.motivo;

        setEnvioAnteojoArregloData({
          ...envioAnteojoArregloData,
          codigoEnvioAnteojoArreglo: _envioAnteojoArregloData.codigo,
          sucursalDestino: _envioAnteojoArregloData.descripcion_area_destino,
          fechaRegistracion: _envioAnteojoArregloData.fecha_creacion,
          observaciones: _envioAnteojoArregloData.observaciones,
          anulado: _anulado,
          motivoAnulacion: _motivoAnulacion,
        });

        setEnvioAnteojoArregloList(_envioAnteojoArregloList);
        setEnvioAnteojoArregloEstadoRows(_envioAnteojoArregloEstados);
      } else {
        setMessage({
          messageText: response.messageText,
          severity: response.messageSeverity,
        });
        setShowMessage(true);
      }
    };
    loadEnvioAnteojoArreglo();
  }, []);
  //
  // ################################################################################
  //
  const handleChange = (e) => {
    setEnvioAnteojoArregloData({
      ...envioAnteojoArregloData,
      [e.target.name]: e.target.value,
    });
  };
  //
  // ##########################################################################
  //
  const handleSave = () => {
    if (!envioAnteojoArregloData.motivoAnulacion) {
      setMessage({
        messageText: "Debes ingresar un motivo de anulación del Envio de Anteojos/Arreglos",
        severity: "error",
      });
      setShowMessage(true);
      return;
    }

    let _envioAnteojoArregloObject = {
      id: idEnvioAnteojoArreglo,
      motivo_anulacion: envioAnteojoArregloData.motivoAnulacion,
    };

    save(_envioAnteojoArregloObject);
  };
  //
  // ################################################################################
  //
  const save = async (parEnvioAnteojoArreglo) => {
    setIsDoingSomething(true);
    const response = await invalidateEnvioAnteojoArreglo(parEnvioAnteojoArreglo);
    setIsDoingSomething(false);

    if (response.ok) {
      setMessage({
        messageText: "Envío de Anteojos/Arreglos anulado",
        severity: "success",
      });
      setShowMessage(true);
      setTimeout(() => {
        handleCancelar();
      }, 1000);
    } else {
      setMessage({
        messageText: response.messageText,
        severity: response.messageSeverity,
      });
      setShowMessage(true);
    }
  };
  //
  // ##########################################################################
  //
  const handleAnteojoArreglo = (parRow) => {
    setAnteojoArreglo(parRow.anteojo_arreglo);
    setCodigoAnteojoArreglo(parRow.codigo_anteojo_arreglo);
    setIdGcAnteojoArreglo(parRow.id_gc_anteojo_arreglo);
    setIdGestionAtencion(parRow.id_gc);
    setOpenVerAnteojoArregloDialog(true);
  };
  //
  // ################################################################################
  //
  const handleCloseDialog = () => {
    setOpenAnteojoArregloDialog(false);
  };
  //
  // ################################################################################
  //
  const handleCloseVerAnteojoArregloDialog = () => {
    setOpenVerAnteojoArregloDialog(false);
  };
  //
  // ##########################################################################
  //
  const handleCancelar = () => {
    navigate("/envio-anteojo-arreglo-table");
  };
  //
  // ################################################################################
  //
  return (
    <Box sx={{
      m: 1, p: 2,
      pt: 2,
      border: "1px solid LightGrey",
      borderRadius: "5px",
      backgroundColor: "primary",
    }}
      className="box-table"
    >
      <Paper elevation={0} sx={{ mx: 0.5, maxWidth: "100%" }}>
        <Paper elevation={2} >
          <Box sx={{ mb: 1, p: 1 }}>
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <Typography variant="h5" display="block" gutterBottom>
                  {title}
                </Typography>
              </Grid>
            </Grid>

            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} sm={8} md={4} lg={4}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                  }}
                  id="sucursalDestino"
                  label="Sucursal de Destino"
                  variant="outlined"
                  size="small"
                  name="sucursalDestino"
                  value={envioAnteojoArregloData.sucursalDestino}
                  onChange={handleChange}
                  InputProps={{ readOnly: true, autoComplete: "off" }}
                />
              </Grid>

              <Grid item xs={12} sm={8} md={2} lg={2}>
                <TextField
                  sx={{ width: "100%" }}
                  inputProps={{
                    autoComplete: "off",
                    maxLength: 3,
                  }}
                  id="fechaRegistracion"
                  label="Fecha de Registración"
                  variant="outlined"
                  size="small"
                  name="fechaRegistracion"
                  value={envioAnteojoArregloData.fechaRegistracion}
                  InputProps={{ readOnly: true }}
                />
              </Grid>

              <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
            </Grid>

            {envioAnteojoArregloData.observaciones && (
              <Grid container sx={{ mt: 1 }}>
                <Grid item xs={12} sm={12} md={6} lg={6}>
                  <TextField
                    sx={{
                      "& .MuiInputBase-root": {
                        minHeight: "80px",
                        minWidth: "400px",
                      },
                    }}
                    id="observaciones"
                    label="Observaciones"
                    variant="outlined"
                    name="observaciones"
                    value={envioAnteojoArregloData.observaciones}
                    onChange={handleChange}
                    InputProps={{
                      readOnly: action !== "new",
                      autoComplete: "off",
                    }}
                    multiline
                    rows={3}
                    fullWidth
                  />
                </Grid>

                <Grid item xs={12} sm={12} md={6} lg={6}></Grid>
              </Grid>
            )}

            <Grid container sx={{ mt: 1 }} spacing={1}>
              <Grid item xs={12} sm={12} md={6} lg={6}>
                {(envioAnteojoArregloData.anulado || action === "delete") && (
                  <TextField
                    autoFocus
                    sx={{ width: "100%" }}
                    inputProps={{
                      autoComplete: "off",
                    }}
                    id="motivoAnulacion"
                    label="Motivo de Anulación"
                    variant="outlined"
                    size="small"
                    name="motivoAnulacion"
                    value={envioAnteojoArregloData.motivoAnulacion}
                    onChange={handleChange}
                    InputProps={{
                      readOnly: envioAnteojoArregloData.anulado || action === "view",
                      autoComplete: "off",
                    }}
                  />
                )}
              </Grid>
            </Grid>
          </Box>

          <Box sx={{ border: "1px solid LightGrey", mb: 2, p: 1, borderRadius: "5px" }}>
            <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
              Anteojos/Arreglos enviados
            </Typography>
            <DataGrid
              rows={envioAnteojoArregloList}
              columns={tableColumns}
              {...tableOptions}
            />
          </Box>

          {envioAnteojoArregloEstadoRows.length > 0 && (
            <Box sx={{ border: "1px solid LightGrey", mb: 2, p: 1, borderRadius: "5px" }}>
              <Typography variant="subtitle1" sx={{ mt: 1, ml: 1 }}>
                Estados del Envío de Anteojos/Arreglos
              </Typography>
              <DataGrid
                rows={envioAnteojoArregloEstadoRows}
                columns={tableColumnsEstado}
                {...tableOptions}
              />
            </Box>
          )}

          <Box sx={{ m: 1, p: 1 }}>
            <Grid container spacing={1} justifyContent="flex-end">
              {action === "delete" && (
                <Grid item xs={12} md={2} lg={1}>
                  <Button
                    sx={{ mr: 1, width: "100%" }}
                    variant="contained"
                    size="small"
                    startIcon={<RemoveCircleOutlineOutlinedIcon />}
                    onClick={handleSave}
                  >
                    Anular
                  </Button>
                </Grid>
              )}

              <Grid item xs={12} md={2} lg={1}>
                <Button
                  sx={{ mr: 1, width: "100%" }}
                  variant="outlined"
                  size="small"
                  onClick={handleCancelar}
                  startIcon={action === "view" ? <KeyboardReturn /> : <Cancel />}
                >
                  {action === "view" ? "Volver" : "Cancelar"}
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Paper>
      </Paper>

      {/* >>> dialog para agregar Anteojo/Arreglo */}

      {openAnteojoArregloDialog && (
        <EnvioAnteojoArregloDialog
          actionCrud={actionCrud}
          anteojoArregloItem={anteojoArregloItem}
          onSave={handleSaveDialog}
          onClose={handleCloseDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {/* >>>> dialog para ver anteojo / arreglo */}

      {openVerAnteojoArregloDialog && (
        <VerAnteojoArregloDialog
          idGestionAtencion={idGestionAtencion}
          anteojoArreglo={anteojoArreglo}
          codigoAnteojoArreglo={codigoAnteojoArreglo}
          idGcAnteojoArreglo={idGcAnteojoArreglo}
          onClose={handleCloseVerAnteojoArregloDialog}
          setMessage={setMessage}
          setShowMessage={setShowMessage}
        />
      )}

      {showMessage && (
        <Message
          showMessage={showMessage}
          setShowMessage={setShowMessage}
          message={message}
        />
      )}

      <WaitingDialog open={isDoingSomething} />
    </Box>
  );
};
export default EnvioAnteojoArreglo;
